import Link from "next/link";
import React from "react";

import theme from "@/styles/themes/theme";
import { Stack, Typography } from "@mui/material";
import { List } from "@phosphor-icons/react";

interface Props {
  title: string;
  subtitle: string;
}

const CategoryHeader: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <Stack
      display="flex"
      flexDirection={{ sm: "row", xs: "column" }}
      alignItems={{ sm: "center", xs: "start" }}
      justifyContent="space-between"
      spacing={2}
      mb={6}
    >
      <Stack>
        <Typography variant="h5" fontWeight={400}>
          {title ?? "TROQUE SEUS PONTOS KMV"}
        </Typography>

        <Typography variant="h5" color={theme.palette.info.main} fontWeight={600}>
          {subtitle}
        </Typography>
      </Stack>
      <Link href="/categorias" style={{ color: theme.palette.secondary.main, display: "flex", gap: 8, fontWeight: 500 }}>
        <List size={24} color={theme.palette.secondary.main} fontWeight={600} />
        <Typography variant="button" sx={{ color: theme.palette.secondary.main, fontWeight: 400 }}>
          CONFIRA TODAS AS CATEGORIAS
        </Typography>
      </Link>
    </Stack>
  );
};

export default CategoryHeader;
